<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body pb-10 pt-10">
          <div class="col-lg-11">
            <b-form @submit.stop.prevent="onSubmit">
              <!-- Image -->
              <b-row class="mb-5">
                <b-col sm="2"></b-col>
                <b-col sm="10">
                  <div v-if="preview">
                    <img class="logo-image-preview " :src="preview" />
                  </div>
                  <div v-else-if="preview_image != null">
                    <img class="logo-image-preview" :src="this.preview_image" />
                  </div>
                </b-col>
              </b-row>

              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.COMPANY_MANAGEMENT.FORM.FIELDS.LOGO_IMAGE") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-file
                    id="logo_image"
                    name="logo_image"
                    type="file"
                    v-model="$v.form.logo_image.$model"
                    accept="image/*"
                    @change="loadFile($event)"
                    placeholder="No logo image chosen"
                    :state="validateState('logo_image')"
                    aria-describedby="logo_image-live-feedback"
                  ></b-form-file>
                  <b-form-invalid-feedback id="logo_image-live-feedback">
                    <span v-if="!$v.form.logo_image.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <!-- Name -->
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>{{ $t("PAGE.COMPANY_MANAGEMENT.FORM.FIELDS.NAME") }}</h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    id="name-input"
                    name="name-input"
                    type="text"
                    v-model="$v.form.name.$model"
                    :state="validateState('name')"
                    aria-describedby="name-live-feedback"
                  ></b-form-input>

                  <b-form-invalid-feedback id="name-live-feedback">
                    <span v-if="!$v.form.name.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                    <span v-if="!$v.form.name.maxLength" class="error">
                      {{
                        $t("PAGE.DEFAULT.FORM.VALIDATION.MAX_LENGTH", {
                          max: 256
                        })
                      }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
           

              <b-row>
                <b-col sm="12">
                  <b-button class="float-right" @click.prevent="cancel()">{{
                    $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                  }}</b-button>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="float-right mr-3"
                    >{{ $t("PAGE.DEFAULT.FORM.BTN_SUBMIT") }}</b-button
                  >
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.logo-image-preview {
  margin-left: 30%;
  width: 120px;
  height: 120px;
  object-fit: cover;
  object-position: center;
  border: solid 1px #ccc;
  border-radius: 100%;
}

</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {
  POST_COMPANY_MANAGEMENT_DATA,
  SET_IS_CLEAR_PAGINATION,
  GET_COMPANY_MANAGEMENT_DATA,
  PUT_COMPANY_MANAGEMENT_DATA
} from "@/core/services/store/company_management.module";

export default {
  mixins: [validationMixin],
  data() {
    return {
      //value: [],
      id: 0,
      form: {
        name: "",
        logo_image: null,
      },
      preview_image: null,
      preview: null
    };
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(256)
      },
      logo_image: {
        required
      },
    }
  },
  computed: {},
  mounted() {
    this.id = this.$route.params.id;
 
    if (this.id > 0) {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
          route: "../../company-management"
        },
        { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
      ]);

     this.getCompany(this.id);
    } else {
      this.$store.dispatch(SET_BREADCRUMB, [
        {
          title: `${this.$t("MENU.COMPANY_MANAGEMENT.TITLE")}`,
          route: "../company-management"
        },
        { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
      ]);
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let formData = new FormData();
      formData.append("name", this.form.name);
      formData.append("logo_image", this.form.logo_image);
      this.id > 0 ? this.update(this.id, formData) : this.create(formData);
    },
   

    create(data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(POST_COMPANY_MANAGEMENT_DATA, { data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `สร้างข้อมูลเรียบร้อยแล้ว`
                });
                this.$router.push("../company-management");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    
    getCompany(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_COMPANY_MANAGEMENT_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                for (const formKey of Object.keys(this.form)) {
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
                if(data.data.logo_image){
                this.preview_image = `${process.env.VUE_APP_IMAGE}${data.data.logo_image}`;}
                else{
                this.preview_image = "media/company/default.png";}
             } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_COMPANY_MANAGEMENT_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
                this.$router.push("../../company-management");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
              });
            });
        }
      });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      this.$router.push(this.id > 0 ? "../../company-management" : "../company-management");
    },

    loadFile(event) {
      try {
        this.preview = URL.createObjectURL(event.target.files[0]);
      } catch {
        this.preview = null;
      }
    }
  }
};
</script>
